/* Badass Banners 2026 — gallery sheet, size picker, live price calculator, Zakeke hooks */
(function(){
  var PRICE_PER_SQFT = 4;
  function money(n){ return '$' + (Math.round(n*100)/100).toFixed(n % 1 ? 2 : 0); }
  function sqftCeil(wIn, hIn){ return Math.ceil((wIn * hIn) / 144 - 1e-9); }
  function priceFor(wIn, hIn){ return sqftCeil(wIn, hIn) * PRICE_PER_SQFT; }
  function readJSON(id){ var el=document.getElementById(id); if(!el) return null; try{return JSON.parse(el.textContent);}catch(e){return null;} }
  window.BB = { priceFor: priceFor, sqftCeil: sqftCeil };

  /* ---------- Template gallery: dynamic occasion tabs, deep links, batches, lazy paging ---------- */
  var gallery = document.querySelector('[data-bb-gallery]');
  function sortCards(grid){
    var arr = Array.prototype.slice.call(grid.querySelectorAll('.bb-card'));
    arr.sort(function(a,b){ return (+a.dataset.sort||9999) - (+b.dataset.sort||9999) || a.dataset.name.localeCompare(b.dataset.name); });
    arr.forEach(function(c){ grid.appendChild(c); });
  }
  if (gallery){
    var grid = gallery.querySelector('[data-bb-grid]');
    var full = gallery.dataset.full === 'true';
    if (grid) sortCards(grid);
    if (full && grid){
      var tabs = gallery.querySelector('[data-bb-tabs]');
      var moreBtn = gallery.querySelector('[data-bb-more]');
      var emptyEl = gallery.querySelector('[data-bb-empty]');
      var countEl = gallery.querySelector('[data-bb-count]');
      var BATCH = +gallery.dataset.batch || 24;
      var limit = BATCH, current = 'all', loading = null;
      var params = new URLSearchParams(location.search);
      var want = (params.get('occasion') || (location.hash || '').replace('#','') || 'all').toLowerCase();
      function label(o){ return o.replace(/[-_ ]+/g,' ').replace(/\b\w/g, function(m){ return m.toUpperCase(); }); }
      function chipFor(o){ return tabs.querySelector('[data-bb-filter="'+ (window.CSS && CSS.escape ? CSS.escape(o) : o) +'"]'); }
      function addChip(o){
        if (!o || chipFor(o)) return;
        var a = document.createElement('a'); a.className = 'bb-chip'; a.dataset.bbFilter = o; a.textContent = label(o);
        a.href = '?view=templates&occasion=' + encodeURIComponent(o); bindChip(a); tabs.appendChild(a);
      }
      function render(){
        var shown = 0, matches = 0;
        grid.querySelectorAll('.bb-card').forEach(function(c){
          var ok = current === 'all' || c.dataset.occasion === current;
          if (ok) matches++;
          c.hidden = !(ok && shown < limit);
          if (!c.hidden) shown++;
        });
        tabs.querySelectorAll('[data-bb-filter]').forEach(function(t){
          var on = t.dataset.bbFilter === current; t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current','true'); else t.removeAttribute('aria-current');
        });
        var hasNext = !!grid.dataset.next;
        if (moreBtn) moreBtn.hidden = !(matches > shown || hasNext);
        if (emptyEl) emptyEl.hidden = !(matches === 0 && !hasNext && !loading);
        if (countEl) countEl.textContent = matches ? (shown + ' of ' + matches + (hasNext ? '+' : '') + ' templates') : '';
        var act = chipFor(current);
        if (act && tabs.scrollWidth > tabs.clientWidth){ /* only scroll the chip row if the active chip is off-screen */
          var tr = tabs.getBoundingClientRect(), ar = act.getBoundingClientRect();
          if (ar.right > tr.right - 8 || ar.left < tr.left) tabs.scrollLeft += (ar.left - tr.left) - 24;
        }
      }
      function loadNext(){
        if (loading || !grid.dataset.next) return loading || Promise.resolve();
        var u = new URL(grid.dataset.next, location.href);
        u.searchParams.set('section_id', gallery.dataset.sectionId);
        loading = fetch(u.toString(), {credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g2 = doc.querySelector('[data-bb-grid]');
          if (g2){
            g2.querySelectorAll('.bb-card').forEach(function(c){ var n = document.importNode(c, true); if (window.bindCard) window.bindCard(n); grid.appendChild(n); addChip(n.dataset.occasion); });
            if (g2.dataset.next) grid.dataset.next = g2.dataset.next; else delete grid.dataset.next;
          } else delete grid.dataset.next;
          sortCards(grid);
        }).catch(function(){ delete grid.dataset.next; }).then(function(){ loading = null; render(); });
        return loading;
      }
      function loadAllForFilter(){
        /* a filtered view must see every page so no template is missed */
        if (current !== 'all' && grid.dataset.next) loadNext().then(loadAllForFilter);
      }
      function setFilter(o, push){
        current = o || 'all'; limit = BATCH;
        if (push){
          var u = new URL(location.href); u.hash = '';
          if (current === 'all') u.searchParams.delete('occasion'); else u.searchParams.set('occasion', current);
          history.replaceState(null, '', u.toString());
        }
        render(); loadAllForFilter();
      }
      function bindChip(a){ a.addEventListener('click', function(e){ e.preventDefault(); setFilter(a.dataset.bbFilter, true); }); }
      tabs.querySelectorAll('[data-bb-filter]').forEach(bindChip);
      if (moreBtn){
        moreBtn.addEventListener('click', function(){
          var matches = grid.querySelectorAll(current === 'all' ? '.bb-card' : '.bb-card[data-occasion="'+current+'"]').length;
          limit += BATCH;
          if (limit > matches && grid.dataset.next) loadNext(); else render();
        });
        /* no auto-click on scroll: the button reveals the next batch when the customer clicks it */
      }
      /* deep link to an occasion that only exists on a later page: create its tab while loading */
      if (want !== 'all' && !chipFor(want) && grid.dataset.next) addChip(want);
      setFilter(chipFor(want) ? want : 'all', false);
    }
  }
  var sheet = document.getElementById('bbSheet');
  var SIZES = readJSON('bb-sizes-data') || [];
  if (sheet){
    var cur = null, curSize = null;
    var goBtn = sheet.querySelector('[data-bb-go]');
    var priceEl = sheet.querySelector('[data-bb-sheet-price]');
    var sizeWrap = sheet.querySelector('[data-bb-sheet-sizes]');
    function renderSheet(){
      sizeWrap.innerHTML = '';
      SIZES.forEach(function(s){
        var b = document.createElement('button'); b.type='button'; b.className='bb-size';
        b.setAttribute('aria-pressed', s.key===curSize ? 'true':'false');
        b.innerHTML = '<b>'+s.label+'</b><small>'+s.price_label+'</small>';
        b.addEventListener('click', function(){ curSize = s.key; renderSheet(); });
        sizeWrap.appendChild(b);
      });
      var s = SIZES.filter(function(x){return x.key===curSize;})[0] || SIZES[0];
      if (!s) return;
      priceEl.textContent = s.price_label;
      var tid = cur.ids && cur.ids[s.key];
      // Zakeke direct URL for a pre-designed template on Shopify: /apps/zakeke?pid=<product id>&template=<id> (zakeke.zendesk.com/hc/en-us/articles/4839839434140). Sizes still on TODO open the size product page instead.
      if (tid && tid !== 'TODO') goBtn.href = (window.BB_ZAKEKE_PATH || '/apps/zakeke') + '?pid=' + s.pid + '&handle=' + s.handle + '&template=' + encodeURIComponent(tid) + '&quantity=1';
      else goBtn.href = s.url + '?template=' + encodeURIComponent(cur.slug);
    }
    window.bindCard = function(card){
      card.addEventListener('click', function(){
        cur = { slug: card.dataset.slug, name: card.dataset.name, img: card.dataset.img, edits: card.dataset.edits, ids: JSON.parse(card.dataset.ids || '{}') };
        curSize = curSize || ((SIZES.filter(function(x){return x.key==='3x6';})[0] || SIZES[0] || {}).key);
        sheet.querySelector('[data-bb-sheet-img]').src = cur.img;
        sheet.querySelector('[data-bb-sheet-img]').alt = cur.name + ' banner template';
        sheet.querySelector('[data-bb-sheet-name]').textContent = cur.name;
        try { sessionStorage.setItem('bb_tpl_' + cur.slug, JSON.stringify({slug:cur.slug, name:cur.name, img:cur.img, ids:cur.ids})); } catch(e){}
        renderSheet();
        if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open','');
      });
    };
    document.querySelectorAll('.bb-card').forEach(window.bindCard);
    sheet.querySelector('[data-bb-close]').addEventListener('click', function(){ sheet.close ? sheet.close() : sheet.removeAttribute('open'); });
    sheet.addEventListener('click', function(e){ if (e.target === sheet) sheet.close(); });
  }

  /* ---------- Product page ---------- */
  var pdp = document.querySelector('[data-bb-pdp]');
  if (!pdp) return;
  var sizeKey = pdp.dataset.sizeKey; // '2x4' ... or 'custom'
  var params = new URLSearchParams(location.search);
  var tplSlug = params.get('template');
  var TPLS = readJSON('bb-templates-data') || [];
  var tpl = tplSlug ? TPLS.filter(function(t){ return t.slug === tplSlug; })[0] : null;
  if (!tpl && tplSlug){ try { tpl = JSON.parse(sessionStorage.getItem('bb_tpl_' + tplSlug) || 'null'); } catch(e){} }
  if (tpl){
    var pill = document.getElementById('bbTplPill');
    if (pill){ pill.hidden = false; pill.querySelector('img').src = tpl.img; pill.querySelector('img').alt = tpl.name; pill.querySelector('[data-name]').textContent = tpl.name; }
    // keep the chosen template when switching sizes
    pdp.querySelectorAll('a.bb-size').forEach(function(a){ var u = new URL(a.href, location.href); u.searchParams.set('template', tplSlug); a.href = u.toString(); });
  }
  // Open Zakeke with the chosen pre-designed template.
  // Zakeke's Shopify direct-URL format is /apps/zakeke?pid=<Shopify product id>&template=<template ID>
  // (https://zakeke.zendesk.com/hc/en-us/articles/4839839434140). The legacy injector (portal.zakeke.com product.js)
  // builds /apps/zakeke?pid=..&handle=..&locale=.. and drops ?template, so when this size has a template ID we
  // catch the Customize click first (capture phase) and go to the direct URL instead.
  var tplId = (tpl && tpl.ids && tpl.ids[sizeKey] && tpl.ids[sizeKey] !== 'TODO') ? String(tpl.ids[sizeKey]) : null;
  function zakekeTemplateUrl(){
    var u = new URL((window.zakekeUrl || '/apps/zakeke'), location.origin);
    u.searchParams.set('pid', pdp.dataset.productId);
    u.searchParams.set('handle', pdp.dataset.handle);
    u.searchParams.set('template', tplId);
    u.searchParams.set('quantity', '1');
    return u.toString();
  }
  if (tplId && pdp.dataset.productId){
    document.addEventListener('click', function(e){
      var btn = e.target && e.target.closest && e.target.closest('#zakeke-product-button, .zakeke-product-button');
      if (!btn) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.href = zakekeTemplateUrl();
    }, true);
  }
  // Newer Zakeke app-block hook (customize-button.js), kept for when the app block replaces the legacy injector.
  window.zakekeCustomizeButtonCustomAction = function(url){
    if (tplId) url.searchParams.set('template', tplId);
    window.location.href = url.toString();
  };

  /* live price calculator (custom size) */
  var calc = pdp.querySelector('[data-bb-calc]');
  var unit = 'ft';
  function inches(v){ v = parseFloat(String(v).replace(',','.')); if (!isFinite(v) || v <= 0) return 0; return Math.round(unit === 'ft' ? v*12 : v); }
  function update(){
    if (!calc) return;
    var w = inches(calc.querySelector('[data-w]').value), h = inches(calc.querySelector('[data-h]').value);
    var minIn = +calc.dataset.min, maxShort = +calc.dataset.maxShort, maxLong = +calc.dataset.maxLong;
    var out = calc.querySelector('[data-bb-calc-price]'), note = calc.querySelector('[data-bb-calc-note]'), big = calc.querySelector('[data-bb-calc-big]');
    if (!w || !h){ out.textContent = '—'; note.textContent = 'Enter width and height'; big.hidden = true; setSticky('—'); return; }
    var shortS = Math.min(w,h), longS = Math.max(w,h);
    var tooBig = shortS > maxShort || longS > maxLong, tooSmall = shortS < minIn;
    big.hidden = !tooBig;
    calc.querySelector('[data-bb-calc-small]').hidden = !tooSmall;
    var sq = sqftCeil(w,h), p = sq * PRICE_PER_SQFT;
    out.textContent = tooBig ? 'Call us' : (tooSmall ? '—' : money(p));
    function n2(x){ return String(Math.round(x*100)/100); } // fixes "20 ft" showing as "2"
    note.textContent = n2(w/12) + ' × ' + n2(h/12) + ' ft (' + w + ' × ' + h + ' in) = ' + n2(w*h/144) + ' sq ft → billed as ' + sq + ' sq ft × $4';
    setSticky(tooBig ? 'Call' : (tooSmall ? '—' : money(p)));
    calc.dataset.valid = (tooBig || tooSmall) ? 'false' : 'true';
    try { sessionStorage.setItem('bbCustomSize', JSON.stringify({w:w,h:h})); } catch(e){}
  }
  if (calc){
    calc.querySelectorAll('input').forEach(function(i){ i.addEventListener('input', update); });
    calc.querySelectorAll('[data-unit]').forEach(function(b){
      b.addEventListener('click', function(){
        var nu = b.dataset.unit; if (nu === unit) return;
        calc.querySelectorAll('[data-w],[data-h]').forEach(function(i){ var v = parseFloat(i.value)||0; i.value = nu === 'in' ? Math.round(v*12) : +(v/12).toFixed(2); });
        unit = nu; calc.querySelectorAll('[data-unit]').forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.unit===unit?'true':'false'); });
        calc.querySelectorAll('[data-unit-label]').forEach(function(l){ l.textContent = unit; });
        update();
      });
    });
  }

  /* sticky mobile bar proxies to the single primary button */
  var sticky = document.getElementById('bbSticky');
  function setSticky(t){ var s = sticky && sticky.querySelector('[data-bb-sticky-price]'); if (s) s.textContent = t; }
  function primaryBtn(){ return pdp.querySelector('.bb-buy #zakeke-product-button, .bb-buy .zakeke-product-button, .bb-buy button[id*=zakeke], #zakeke-product-button'); }
  if (sticky){
    sticky.querySelector('[data-bb-sticky-go]').addEventListener('click', function(e){
      e.preventDefault(); var b = primaryBtn();
      if (b) b.click(); else document.getElementById('bbBuy').scrollIntoView({behavior:'smooth', block:'center'});
    });
    var buy = document.getElementById('bbBuy');
    if ('IntersectionObserver' in window && buy){
      new IntersectionObserver(function(en){ sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(buy);
    }
  }
  update();

  /* fallback if the Zakeke button never appears (product not yet enabled in Zakeke) */
  /* exactly ONE primary button: if both the app block and the legacy injector render one, keep the first */
  function dedupe(){
    var all = Array.prototype.slice.call(pdp.querySelectorAll('#zakeke-product-button, .zakeke-product-button, .bb-buy .shopify-app-block button'));
    var seen = false;
    all.forEach(function(b){ if (b.offsetParent === null && !seen) return; if (seen) b.style.display = 'none'; else seen = true; });
    var fb = document.getElementById('bbFallback'); if (fb && seen) fb.hidden = true;
    return seen;
  }
  if ('MutationObserver' in window){ new MutationObserver(dedupe).observe(document.getElementById('bbBuy') || pdp, {childList:true, subtree:true}); }
  setTimeout(function(){
    if (!dedupe() && !primaryBtn()){ var fb = document.getElementById('bbFallback'); if (fb) fb.hidden = false; }
  }, 5000);
})();
